import type { AnnouncementBarData } from '@/types'
import { toExternalUrl } from '../utils/omp'

interface OmpAnnouncementBarProps {
  data?: AnnouncementBarData
}

const OmpAnnouncementBar = ({ data }: OmpAnnouncementBarProps) => {
  if (!data?.text) {
    return null
  }

  const href = toExternalUrl(data.link_url)
  const content = (
    <span
      className="omp-announcement-text rich-text"
      style={{ color: data.banner_text_color || '#FFFFFF' }}
      dangerouslySetInnerHTML={{ __html: data.text }}
    />
  )

  return (
    <div className="omp-announcement-bar" style={{ backgroundColor: data.banner_background_color || '#000000' }}>
      {href ? (
        <a href={href} target="_blank" rel="noreferrer" className="omp-announcement-link">
          {content}
        </a>
      ) : (
        content
      )}
    </div>
  )
}

export default OmpAnnouncementBar
